import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';  // Import Link from react-router-dom

export default function Navbar(props) {
  return (
    <nav className={`navbar navbar-expand-lg bg-${props.mode}`} data-bs-theme={props.mode}>
      <div className="container-fluid">
        <Link className="navbar-brand" to="/">{props.title}</Link> {/* Use Link instead of <a> */}
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <Link className="nav-link active" aria-current="page" to="/">Home</Link> {/* Use Link instead of <a> */}
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/diff-tool">Diff Tool</Link> {/* New link to Diff Tool page */}
            </li>
          </ul>
          <div className="form-check form-switch">
            <input className="form-check-input" type="checkbox" onClick={props.toggleMode} role="switch" id="flexSwitchCheckDefault" />
            <label className={`form-check-label text-${props.mode === 'light' ? 'dark' : 'light'}`} htmlFor="flexSwitchCheckDefault" data-bs-theme={props.mode}>Enable Dark Mode</label>
          </div>
        </div>
      </div>
    </nav>
  )
}

Navbar.propTypes = {
  title: PropTypes.string
}

Navbar.defaultProps = {
  title: "Set Title Here",
  aboutText: "About"
}
